
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import moment from 'moment-timezone'

import * as _ from 'underscore';
import { dateRangeInfoType } from '@/types/Common';

@Component
export default class DateRangePicker extends Vue {
    
    @Prop({required: true})
    reportRange!: dateRangeInfoType;

    onShow= false
    dates = []

    pickedDates=""
    pickerDateL=""
    pickerDateR=""

    @Watch('pickerDateL')
    monthChange(newValue){
        this.pickerDateR = moment(newValue).add(1,'months').format("YYYY-MM")
    }

    @Watch('pickerDateR')
    monthChangeR(newValue){
        this.pickerDateL = moment(newValue).add(-1,'months').format("YYYY-MM")
    }

    mounted(){
        this.initDates()
    }

    public clearDates(){ 
        this.dates=[null,null]
        // this.AddDates()
    }

    public initDates(){
        this.dates = []
     
        this.dates.push(this.reportRange.startDate?.slice(0,10))
        this.dates.push(this.reportRange.endDate?.slice(0,10))
        this.getDatesText(_.sortBy(this.dates))

        if(this.reportRange.startDate?.slice(0,7)){
            if(this.reportRange.startDate?.slice(0,7) == this.reportRange.endDate?.slice(0,7))
                this.pickerDateR = this.reportRange.startDate.slice(0,7)
            else
                this.pickerDateL = this.reportRange.startDate.slice(0,7)
        }
        else
            this.pickerDateR = moment().format("YYYY-MM")
    }

    public getDatesText(reportDate){

        if(!reportDate[1] || !reportDate[0])
            this.pickedDates ='<b>All dates<b>'
        else
            this.pickedDates ='<b class="mr-1 h3">From </b><span style="font-size:14pt;">'+  moment(reportDate[0]).format("MMM DD, YYYY") + '</span> '+
                              '<b class="ml-3 mr-1 h3">  To </b><span style="font-size:14pt;">'+  moment(reportDate[1]).format("MMM DD, YYYY")+ '</span> ';      
    }

    public AddDates(){
        if(!this.dates[1] || !this.dates[0])
            this.dates=['','']
        this.dates = _.sortBy(this.dates)
        this.getDatesText(this.dates)
        const dateRange: dateRangeInfoType = {
            startDate:moment(this.dates[0]).toISOString() ,
            endDate:moment(this.dates[1]).toISOString()
        }
        this.$emit('datesAdded',dateRange)
        this.onShow= false
    }

    public focusSearchButton(){
        Vue.nextTick(()=>{
            const el = document.getElementsByName("search")[0];
            if(el) el.focus();
        })        
    }

    public allowedDates(date){
        const today = moment().format()
        if(date > today) return false
        else 
            return true
    }

    public setDatesToday(){
        const today = moment().format("YYYY-MM-DD")        
        this.dates=[today, today]
        this.pickerDateR = moment().format("YYYY-MM")
    }

    public setDatesOneWeek(){
        const today = moment().format("YYYY-MM-DD")
        const nextWeek = moment().add(-6,'days').format("YYYY-MM-DD")        
        this.dates=[today, nextWeek]
        this.pickerDateR = moment().format("YYYY-MM")
    }

    public setDatesTwoWeeks(){
        const today = moment().format("YYYY-MM-DD")
        const twoWeek = moment().add(-13,'days').format("YYYY-MM-DD")
        this.dates=[today, twoWeek]
        this.pickerDateR = moment().format("YYYY-MM")
    }

    public setDatesOneMonth(){
        const today = moment().format("YYYY-MM-DD")
        const oneMonth = moment(today).add(-1,'month').format("YYYY-MM-DD")       
        this.dates=[today, oneMonth]
    }
}
